import { rePriceCalculationTypeConstants } from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : null,
	list       : null,
	changed    : null
}

export default function (state = initialState, action){
	switch (action.type){
		case rePriceCalculationTypeConstants.GetPaged.REQUEST:
		case rePriceCalculationTypeConstants.GetPagedAll.REQUEST:
		case rePriceCalculationTypeConstants.GetList.REQUEST:
		case rePriceCalculationTypeConstants.Create.REQUEST:
		case rePriceCalculationTypeConstants.Delete.REQUEST:
		case rePriceCalculationTypeConstants.Restore.REQUEST:
		case rePriceCalculationTypeConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case rePriceCalculationTypeConstants.GetPaged.FAILURE:
		case rePriceCalculationTypeConstants.GetPagedAll.FAILURE:
		case rePriceCalculationTypeConstants.GetList.FAILURE:
		case rePriceCalculationTypeConstants.Create.FAILURE:
		case rePriceCalculationTypeConstants.Delete.FAILURE:
		case rePriceCalculationTypeConstants.Restore.FAILURE:
		case rePriceCalculationTypeConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case rePriceCalculationTypeConstants.GetPaged.SUCCESS:
		case rePriceCalculationTypeConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case rePriceCalculationTypeConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case rePriceCalculationTypeConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case rePriceCalculationTypeConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case rePriceCalculationTypeConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case rePriceCalculationTypeConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case rePriceCalculationTypeConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : null,
				list       : null
			}
		default:
			return state
	}
}